import { Card, CardContent, Box, Typography } from '@mui/material';
import { Scan,Contactless,SearchCheck } from "@mynaui/icons-react";

import { QrCode } from '@mui/icons-material';

const QuickActionCard = ({ action, onClick }) => {
  const getIcon = (iconType) => {
    const iconProps = { fontSize: 32, color: '#fff' };
    
    switch (iconType) {
      case 'qr':
        return <Scan style={{ color: '#fff', fontSize: 48 }} />;
      case 'nfc':
        return <Contactless style={{ color: '#fff', fontSize: 48 }} />;
      case 'search':
        return <SearchCheck style={{ color: '#fff', fontSize: 48 }} />;
      default:
        return <QrCode {...iconProps} />;
    }
  };

  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid #E0E0E0',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <CardContent sx={{ padding: '24px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '12px',
              backgroundColor: action.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {getIcon(action.icon)}
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '1.125rem',
                marginBottom: '4px',
                color: '#212121',
              }}
            >
              {action.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#757575',
                fontSize: '0.875rem',
              }}
            >
              {action.description}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActionCard;